export default {
  types: [
    // {
    //   value: 'catalogue',
    //   name: '目录'
    // },
    {
      value: 'panorama',
      name: '全景'
    },
    {
      value: 'poi',
      name: '兴趣点POI'
    }
  ]
}


// WEBPACK FOOTER //
// ./src/store/config/panorama.js